<template>
  <Card class="SupplierCard">
    <div class="row">
      <div class="col-12">
        <CardBasicInfoBlock
          :data="{
            thumbnail: supplier.logo,
            title: supplier.display_name,
            action: showSupplierDetails,
            actionText: $t('supplierCardContactDetailsButton'),
          }"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="supplierDetailsIsVisible"
      :title="$t('contactDetailsPreviewModalTitle')"
      @update:visible="hideSupplierDetails"
    >
      <SupplierDetails :supplier="supplier" />
    </el-dialog>
  </Card>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'element-ui';
// Components
import Card from '@/components/Card.vue';
import CardBasicInfoBlock from '@/components/cardBasicInfo/Block.vue';
import SupplierDetails from '@/components/supplier/Details.vue';

Vue.use(Dialog);

export default {
  name: 'SupplierCard',
  components: {
    Card,
    CardBasicInfoBlock,
    SupplierDetails,
  },
  props: {
    supplier: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      supplierDetailsIsVisible: false,
      data: {
        thumbnail: null,
        title: null,
        action: null,
        actionText: null,
      },
    };
  },
  methods: {
    showSupplierDetails() {
      this.supplierDetailsIsVisible = true;
    },
    hideSupplierDetails() {
      this.supplierDetailsIsVisible = false;
    },
  },
};
</script>
